// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6895":"38b2505b","8837":"2bd5db18"}[chunkId] + ".chunk.css";
};